export const IMAGES = {
  chauffeurDoor: "/editorial/chauffeur-bern.webp",
  traveler: "/editorial/first-interior.webp",
  architecture: "https://images.unsplash.com/photo-1483366774565-c783b9f70e2c?auto=format&fit=crop&w=1400&q=80",
  sedanDark: "/editorial/business-road.webp",
  chauffeurSuit: "/editorial/van-interior.webp",
  carFront: "https://images.pexels.com/photos/244206/pexels-photo-244206.jpeg?auto=compress&cs=tinysrgb&w=1200",
  mercedesSedan: "https://images.unsplash.com/photo-1610099610040-ab19f3a5ec35?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  mercedesSedanStreet: "/fleet/sclass-nature.webp",
  mercedesExec: "/fleet/sclass-museum.webp",
  mercedesBuilding: "/fleet/sclass-hotel.webp",
  mercedesVan: "/fleet/vclass-interior.webp",
  driverPortrait: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=400&q=80",
  planeWing: "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?auto=format&fit=crop&w=1400&q=80",
  carBlue: "https://images.unsplash.com/photo-1555215695-3004980ad54e?auto=format&fit=crop&w=1200&q=80",
  van: "https://images.pexels.com/photos/8425380/pexels-photo-8425380.jpeg?auto=compress&cs=tinysrgb&w=1200",
  citySwiss: "https://images.unsplash.com/photo-1527668752968-14dc70a27c95?auto=format&fit=crop&w=1400&q=80",
  cityLake: "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?auto=format&fit=crop&w=1400&q=80",
  fleetStandard: "/fleet/standard-class.webp",
  fleetStandardStudio: "/fleet/standard-studio.webp",
  fleetBusiness: "/fleet/business-class.webp",
  fleetFirst: "/fleet/first-class.webp",
  fleetVan: "/fleet/van.webp",
};

export const CITIES = [
  "Genève — Centre", "Lausanne — Centre", "Zurich — Centre", "Bâle — Centre", "Berne — Centre",
  "Montreux", "Neuchâtel", "Zoug", "Lugano", "Verbier",
  "Aéroport Genève GVA", "Aéroport Zurich ZRH", "Aéroport Bâle BSL",
];

export const formatChf = (amount) => {
  const value = Number(amount || 0);
  const formatted = value.toLocaleString("fr-CH", {
    minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
    maximumFractionDigits: 2,
  });
  return `CHF ${formatted}${Number.isInteger(value) ? ".–" : ""}`;
};


export const AIRPORTS = ["GVA", "ZRH", "BSL"];

export const VEHICLES = {
  business: { id: "business", name: "Business Class", model: "Mercedes EQE ou Classe E", pax: 3, bags: 3,
    features: ["Wi-Fi à bord", "Eau & chargeurs", "Accueil pancarte aéroport"], image: IMAGES.fleetBusiness, from: 90 },
  first: { id: "first", name: "First Class", model: "Mercedes Classe S ou équivalent", pax: 3, bags: 3,
    features: ["Attente 60 min incluse", "Sièges confort arrière", "Presse du jour"], image: IMAGES.fleetFirst, from: 120 },
  van: { id: "van", name: "VAN", model: "Mercedes Classe V ou équivalent", pax: 6, bags: 8,
    features: ["6 passagers", "Grand coffre", "Idéal groupes & skis"], image: IMAGES.fleetVan, from: 120 },
  standard: { id: "standard", name: "Standard Class", model: "Tesla Model Y ou équivalent", pax: 4, bags: 3,
    features: ["Prix accessible", "100 % électrique", "Silencieux & récent"], image: IMAGES.fleetStandard, from: 60 },
};

export const SERVICES_INDEX = [
  { id: "airport", href: "/aeroports", image: IMAGES.chauffeurDoor },
  { id: "p2p", href: "/services/trajet-direct", image: IMAGES.sedanDark },
  { id: "hourly", href: "/services/mise-a-disposition", image: IMAGES.mercedesSedan },
  { id: "long", href: "/services/longue-distance", image: IMAGES.mercedesSedanStreet },
  { id: "corporate", href: "/business", image: IMAGES.mercedesExec },
  { id: "hotels", href: "/services/hotels-conciergerie", image: IMAGES.mercedesBuilding },
  { id: "events", href: "/services/evenements-groupes", image: IMAGES.mercedesVan },
];

export const SERVICE_PAGES = {
  "trajet-direct": { id: "p2p", cta: "/reservation", image: IMAGES.sedanDark },
  "mise-a-disposition": { id: "hourly", cta: "/reservation?type=hourly", image: IMAGES.mercedesSedan },
  "longue-distance": { id: "long", cta: "/reservation", image: IMAGES.mercedesSedanStreet },
  "hotels-conciergerie": { id: "hotels", cta: "/contact", image: IMAGES.mercedesBuilding },
  "evenements-groupes": { id: "events", cta: "/contact", image: IMAGES.mercedesVan },
};

export const STATUS_LABELS = {
  booked: "Réservé",
  driver_assigned: "Chauffeur attribué",
  driver_on_the_way: "Chauffeur en route",
  driver_arrived: "Chauffeur arrivé",
  on_board: "À bord",
  completed: "Terminé",
};

export const STATUS_ORDER = ["booked", "driver_assigned", "driver_on_the_way", "driver_arrived", "on_board", "completed"];

export const FAQ_ITEMS = [
  { q: "Puis-je réserver sans compte ?", a: "Oui. Nom, téléphone, e-mail : c'est suffisant. Vous recevez immédiatement votre confirmation et votre lien de suivi personnel. Le compte MILES existe, mais il reste facultatif." },
  { q: "Puis-je réserver un aller-retour ?", a: "Oui. Choisissez « Aller-retour » à la première étape : vous indiquez la date et l'heure du retour, et nous planifions les deux courses. Le retour bénéficie d'un tarif ajusté." },
  { q: "Puis-je réserver une mise à disposition ?", a: "Oui, c'est le mode « À l'heure ». Vous choisissez le lieu de départ, la date, l'heure et la durée (2 h minimum). Le chauffeur et le véhicule restent à votre disposition." },
  { q: "Puis-je réserver pour quelqu'un d'autre ?", a: "Oui. Indiquez simplement le nom et le téléphone du passager à l'étape Informations. Il reçoit ses informations et son lien de suivi — sans avoir besoin de créer un compte." },
  { q: "Comment fonctionne le suivi ?", a: "Chaque réservation génère un lien de suivi personnel et sécurisé. Position du chauffeur, statut du trajet et heure d'arrivée estimée s'y mettent à jour en temps réel. Vous pouvez le partager à qui vous voulez." },
  { q: "Quand recevrai-je les informations de mon chauffeur ?", a: "Dès qu'un chauffeur est attribué — prénom, photo, véhicule, couleur et plaque. Pour une réservation immédiate, comptez quelques minutes. Pour une réservation planifiée, au plus tard 1 h avant le départ." },
  { q: "Que se passe-t-il si mon vol est retardé ?", a: "Indiquez votre numéro de vol à la réservation : nous suivons le vol et ajustons automatiquement l'heure de prise en charge à l'atterrissage réel. L'attente à l'aéroport est incluse." },
  { q: "Puis-je modifier ou annuler une réservation ?", a: "Oui, gratuitement jusqu'à 1 h avant le départ pour un trajet simple, et jusqu'à 24 h pour une mise à disposition ou un longue distance. Depuis votre lien de suivi ou en contactant le support." },
  { q: "Comment fonctionne le paiement ?", a: "Le prix est fixé et affiché avant confirmation. Vous payez par carte bancaire de manière sécurisée au moment de la réservation. Le reçu est disponible immédiatement après la course." },
  { q: "Comment fonctionne MILES Business ?", a: "Un espace dédié pour votre organisation : réservez pour un collaborateur, un client ou un invité en quelques secondes, suivez tous les trajets en parallèle, et recevez une facture consolidée en fin de mois." },
  { q: "Comment fonctionne la facturation entreprise ?", a: "Toutes les courses du mois sont regroupées sur une seule facture, avec centres de coûts et références internes si vous le souhaitez. Export PDF et comptable en un clic." },
];

// Pages villes SEO — toponymes canoniques (jamais traduits, utilisés pour le géocodage)
export const CITY_PAGES = {
  geneve: {
    name: "Genève", airport: "GVA", image: IMAGES.citySwiss,
    routes: [
      { from: "Genève", to: "Aéroport Genève GVA", price: "CHF 90.–" },
      { from: "Genève", to: "Lausanne", price: "CHF 210.–" },
      { from: "Genève", to: "Montreux", price: "CHF 310.–" },
      { from: "Genève", to: "Verbier", price: "CHF 525.–" },
    ],
  },
  lausanne: {
    name: "Lausanne", airport: "GVA", image: IMAGES.cityLake,
    routes: [
      { from: "Lausanne", to: "Aéroport Genève GVA", price: "CHF 205.–" },
      { from: "Lausanne", to: "Zurich", price: "CHF 730.–" },
      { from: "Lausanne", to: "Montreux", price: "CHF 100.–" },
    ],
  },
  zurich: {
    name: "Zurich", airport: "ZRH", image: IMAGES.architecture,
    routes: [
      { from: "Zurich", to: "Aéroport Zurich ZRH", price: "CHF 90.–" },
      { from: "Zurich", to: "Bâle", price: "CHF 275.–" },
      { from: "Zurich", to: "Lucerne", price: "CHF 170.–" },
      { from: "Zurich", to: "Saint-Moritz", price: "CHF 665.–" },
    ],
  },
  bale: {
    name: "Bâle", airport: "BSL", image: IMAGES.sedanDark,
    routes: [
      { from: "Bâle", to: "EuroAirport Bâle BSL", price: "CHF 90.–" },
      { from: "Bâle", to: "Zurich", price: "CHF 275.–" },
      { from: "Bâle", to: "Berne", price: "CHF 310.–" },
    ],
  },
  berne: {
    name: "Berne", airport: "ZRH", image: IMAGES.carFront,
    routes: [
      { from: "Berne", to: "Aéroport Zurich ZRH", price: "CHF 430.–" },
      { from: "Berne", to: "Aéroport Genève GVA", price: "CHF 515.–" },
      { from: "Berne", to: "Interlaken", price: "CHF 180.–" },
    ],
  },
};

